import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import strings from '../../components/locales/';
import { Tooltip } from 'react-bootstrap';

/* Function */
import ObjGeneral from '../function/';
/* Local store */
import { localStoreFN } from '../../store/localStorage';
/* Actions */
import * as summaryFulfillmentActions from '../../actions/summary_fulfillment/index';

/* Components */
import Table from '../../components/summary_fulfillment/table';
import TitleMain from '../../components/summary_fulfillment/titleMain';
import TitleMainSecond from '../../components/summary_fulfillment/titleMainSecond';
import Circular from '../../components/summary_fulfillment/circular';
import Header from '../../components/summary_fulfillment/header';
import EvolutionGraph from '../../components/summary_fulfillment/evolutionGraph';
import Loading from '../../components/common/loading';
import Message from '../../components/common/message';

class SummaryFulfillment extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    const permits = localStoreFN().getItem('permits');
    const permit = permits.includes('fatigue');
    if (!permit) {
      this.props.history.push('/dashboard/authorization');
    }
  }

  async componentDidMount() {
    await this.props.actions.fetchSummaryFulfillmentApi({});
  }
  render() {
    return (
      <section className="main">
        <Header language={this.props.language} />
        <div className="main-container">
          {this.props.loading ? (
            <Loading />
          ) : this.props.status === 200 ? (
            <div className="container-summary">
              <TitleMain language={this.props.language} />
              <Circular language={this.props.language} />
              <EvolutionGraph data={this.props.datos.atRiskDailyEvolution} />
              <TitleMainSecond language={this.props.language} />
              <Table data={this.props.datos.atRiskDailyEvolution} language={this.props.language} />
              <Tooltip placement="top" id="pageTooltip" />
            </div>
          ) : this.props.status === 204 ? (
            <Message message={this.props.language.error.apiError500} />
          ) : (
            <Message message={this.props.language.error.apiError} />
          )}
        </div>
      </section>
    );
  }
}
const mapStateToProps = state => ({
  datos: state.reducer.summaryFulfillment.datos,
  loading: state.reducer.summaryFulfillment.loading,
  status: state.reducer.summaryFulfillment.status,
  language: state.reducer.dashboard.language
});
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(summaryFulfillmentActions, dispatch)
});
SummaryFulfillment.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SummaryFulfillment);



// WEBPACK FOOTER //
// ./source/client/containers/summary_fulfillment/index.jsx